import { InboxApi } from '../../models/Inbox';
import { useUserInfo } from '@/hooks';

export const useInboxLockStatus = () => {
  const { id: currentUserId, firstName, lastName } = useUserInfo();
  const fullName = `${firstName} ${lastName}`.trim();

  const getLockStatus = (item: Partial<InboxApi>) => {
    const isLockedByStatus = item.status === 'ATTENDING';
    const amIAttending = item.attentionUserName === fullName;

    const isTakenByOther =
      (item.isTaken && item.takenById && item.takenById !== currentUserId) ||
      (isLockedByStatus && !amIAttending);

    const isManuallyTakenByMe =
      item.isTaken && item.takenById === currentUserId;

    const isTakenByMe =
      isManuallyTakenByMe || (isLockedByStatus && amIAttending);

    return { isTakenByOther, isTakenByMe, isManuallyTakenByMe };
  };

  return { getLockStatus, currentUserId, fullName };
};

export default useInboxLockStatus;
